var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 12.7128C6.01159 12.6506 6.47204 13.3061 10.8882 13.0094C15.3043 12.7128 30.3605 12.6506 43.0331 11.7077M32.2534 5C34.6802 6.48003 40.1896 9.79744 43.0331 10.6537C44.9371 11.2271 46.2885 11.219 43.0331 13.4806C39.7989 15.7273 37.3848 18.192 32.5348 21","stroke":"#021546","strokeWidth":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

RightArrowInline.defaultProps = {"width":"50","height":"26","viewBox":"0 0 50 26","fill":"none"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
